<template>
  <main-layout>
    <b-container class="onboarding-id-page page">
      <div class="page__header text-left">
        <h2>Identification</h2>
      </div>
      <onboarding-id-form />
    </b-container>
  </main-layout>
</template>
<script>
/**
 * ==================================================================================
 * Onboarding validation ID page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'
import OnboardingIdForm from '@/components/forms/OnboardingIDForm'

export default {
  metaInfo: function() {
    return {
      title: 'Upload your IDs'
    }
  },
  components: {
    MainLayout,
    OnboardingIdForm
  }
}
</script>
<style scoped lang="scss">
.onboarding-id-page {
  .page__header {
    padding: 35px 0;
  }
}
</style>
